import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

const useStyles = createUseStyles((theme) => ({
    '@global': {
        body: {
            background: theme.colors.grey100,
            '& li': {
                lineHeight: 'normal'
            }
        }
    }
}));

// eslint-disable-next-line valid-jsdoc
/**
 * Rewrite the global styles from packages/ctm-components/components/page/global.css
 * The best way is adding injectSheet to the top component.
 */
const PageStyledWrapper = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { children, className } = props;

    return (
        <div className={classNames(classes, className)}>
            {children}
        </div>
    );
};

PageStyledWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export { PageStyledWrapper };
